import { Flex, NavLink, Text } from "theme-ui";
import { useTranslation } from "react-i18next";

import { ROUTES } from "src/constants";
import { NavbarProps } from "../Navbar/Navbar.d";
import { extractBaseLang } from "src/utils";

export const NavFooter: React.FC<NavbarProps> = ({
  onNavClick,
  onDownloadClick,
}) => {
  const { t, i18n } = useTranslation();
  const currentLanguage = extractBaseLang(i18n.language);
  return (
    <Flex
      sx={{
        flexDirection: "column",
        display: ["flex", "flex", "flex"],
        fontSize: [2, "15px"],
      }}
    >
      <Text sx={{ mb: [1, 2], color: "white", fontWeight: "heading" }}>
        {t("navigation.interest_links")}
      </Text>
      <NavLink
        onClick={() => onNavClick(ROUTES.answers)}
        sx={{ mb: [1, 2], color: "white", "&:hover": { color: "white" } }}
      >
        {t("navigation.faqs")}
      </NavLink>
      {currentLanguage === "es" && (
        <NavLink
          onClick={() => onNavClick(ROUTES.terms)}
          sx={{ mb: [1, 2], color: "white", "&:hover": { color: "white" } }}
        >
          {t("navigation.terms_and_conds")}
        </NavLink>
      )}
      <NavLink
        onClick={() => onNavClick(ROUTES.contact)}
        sx={{
          color: "white",
          mb: [1, 2],
          "&:hover": { color: "white" },
        }}
      >
        {t("navigation.contact")}
      </NavLink>
    </Flex>
  );
};
